











































































































import {
  defineComponent,
  ref,
  reactive,
  onBeforeUnmount,
  onMounted,
} from '@vue/composition-api';
import LoadingSkeleton from '@/components/loading-skeleton';

import { ubtSendError } from '@/shared/utils/ubt';
// 导入所需的图片资源
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import LoadingSummaryBg from './images/loading-summary-bg@3x.png';
import LoadingItemSuccessImage from './images/loading-item-success@3x.png';
import LoadingItemProcessingImage from './images/loading-item-processing@3x.png';
import LoadingItemWaitingImage from './images/loading-item-waiting@3x.png';
import LoadingReadyVectorImage from './images/loading-ready-vector@3x.png';

/**
 * 加载项状态枚举
 * SUCCESS: 加载成功状态
 * WAITING: 等待加载状态
 * PROCESSING: 加载处理中状态
 */
enum LoadingItemStatus {
  SUCCESS = 'success',
  WAITING = 'waiting',
  PROCESSING = 'processing',
}
/** 倒计时初始秒数 */
const COUNT_DOWN_INIT_SECONDS = 5;

export interface LoadingAnimateRef {
  restartLoading: () => void;
}

export default defineComponent({
  components: {
    LoadingSkeleton,
  },
  props: {
    staticLoadingStyle: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // 倒计时剩余秒数，初始值为5秒
    const lastSecondCount = ref(COUNT_DOWN_INIT_SECONDS);
    /** 是否倒计时状态：当主图片加载完成后(包含加载失败)，可以进入倒计时 */
    const isCountingDown = ref(false);
    /** 存储定时器ID，用于组件销毁时清除 */
    const timerId = ref<number>(0);
    /** 组件渲染完成时间点 */
    const componentLoadedTime = ref(0);

    /**
     * 加载列表状态数据
     * 包含三个加载项：
     * 1. 提交资料（初始为成功状态）
     * 2. 信息加密（初始为处理中状态）
     * 3. 匹配资方（初始为等待状态）
     */
    const loadingListStatus = reactive(props.staticLoadingStyle ? [
      {
        status: LoadingItemStatus.SUCCESS,
        title: '信息已加密保护',
        imageLoaded: false,
      },
      {
        status: LoadingItemStatus.SUCCESS,
        title: '预计20秒内完成额度评估',
        imageLoaded: false,
      },
    ] : [
      {
        status: LoadingItemStatus.SUCCESS,
        title: '正在为您提交资料',
        imageLoaded: false,
      },
      {
        status: LoadingItemStatus.PROCESSING,
        title: '信息已加密保护',
        imageLoaded: false,
      },
      {
        status: LoadingItemStatus.WAITING,
        title: '正在为您匹配资方',
        imageLoaded: false,
      },
    ]);

    /**
     * 加载项图片加载完成回调
     * @param item 加载项对象
     */
    const onLoadingItemImageLoad = (item: any) => {
      item.imageLoaded = true;
    };

    /**
     * 根据加载项状态获取对应的图片URL
     * @param item 加载项对象
     * @returns 对应状态的图片URL
     */
    const getLoadingItemImageUrl = (item: any) => {
      switch (item.status) {
        case LoadingItemStatus.SUCCESS:
          return LoadingItemSuccessImage;
        case LoadingItemStatus.PROCESSING:
          return LoadingItemProcessingImage;
        case LoadingItemStatus.WAITING:
        default:
          return LoadingItemWaitingImage;
      }
    };

    /**
     * 开始倒计时函数
     * 每秒减少计数，并在特定时间点更新加载项状态
     */
    const startCountDown = () => {
      const countDown = () => {
        if (lastSecondCount.value > 0) {
          lastSecondCount.value -= 1;

          /** 倒计时到3秒时，第二条加载项完成loading态，第三条加载项开始loading态 */
          if (lastSecondCount.value === 3 && loadingListStatus[1] && loadingListStatus[2]) {
            loadingListStatus[1].status = LoadingItemStatus.SUCCESS;
            loadingListStatus[2].status = LoadingItemStatus.PROCESSING;
          }

          timerId.value = window.setTimeout(countDown, 1000);
        }
      };

      timerId.value = window.setTimeout(countDown, 1000);
    };

    /**
     * 主图片加载成功回调
     * 设置倒计时状态为true并开始倒计时
     */
    const onLoadedMajorImage = () => {
      isCountingDown.value = true;

      /** 当主图片(盾牌bg)加载完成后，可以开始倒计时 */
      startCountDown();
    };

    /**
     * 主图片加载失败回调
     * 即使加载失败也开始倒计时，并上报错误
     * @param error 错误对象
     */
    const onErrorMajorImage = (error: any) => {
      isCountingDown.value = true;

      /** 当主图片(盾牌bg)加载失败时，也开始倒计时 */
      startCountDown();
      /** 同时上报监控异常 */
      ubtSendError(error);
    };

    onMounted(() => {
      componentLoadedTime.value = Date.now();

      ubtSetupModuleExpose('finance_distribute_loading_enter');
    });

    /**
     * 组件销毁前清除所有定时器
     */
    onBeforeUnmount(() => {
      window.clearTimeout(timerId.value);

      ubtSetupModuleExpose('finance_distribute_loading_exit', {
        stayTime: Date.now() - componentLoadedTime.value,
      });
    });

    return {
      isCountingDown,
      lastSecondCount,
      loadingListStatus,
      LoadingSummaryBg,
      LoadingItemSuccessImage,
      LoadingItemProcessingImage,
      LoadingItemWaitingImage,
      LoadingReadyVectorImage,
      LoadingItemStatus,
      onLoadingItemImageLoad,
      getLoadingItemImageUrl,
      onLoadedMajorImage,
      onErrorMajorImage,
      /** 重置倒计时 */
      restartLoading: () => {
        window.clearTimeout(timerId.value);
        lastSecondCount.value = COUNT_DOWN_INIT_SECONDS;
        startCountDown();
      },
    };
  },
});
